import { connect } from 'react-redux'
import { loadData } from '../../../../actions/warehouse_rent_list_actions'
import { RentList, Element } from '../../warehouse_rent_list_app/warehouse_rent_list/warehouse_rent_list_types'

interface StateProps {
  warehouseRentList: RentList | null
  reservations: any[]
  currentListId: string | null
  elementGroups: Record<string, string>
  groupedAvailableElements: Record<string, Element[]>
  rentElementRequestInProgress: boolean
  rentedItems: Record<string, any>
  errors: string[]
}

interface OwnProps {
  warehouseId: number
  isOverview: boolean
  initialWarehouseRentList: RentList | null
  startDate: string
  endDate: string
  initialData: {
    rentedItems: Record<string, any>
    elementGroups: Record<string, string>
    groupedAvailableElements: Record<string, Element[]>
  }
}

interface DispatchProps {
  loadData: (data: any) => void
}

function mapStateToProps(state: any, props: OwnProps): StateProps {
  return {
    warehouseRentList: state.warehouseRentList.currentList,
    reservations: state.warehouseRentList.reservations || [],
    currentListId: state.warehouseRentList.currentList?.id?.toString(),
    elementGroups: state.warehouseRentList?.elementGroups || {},
    groupedAvailableElements: state.warehouseRentList?.groupedAvailableElements || {},
    rentElementRequestInProgress: state.warehouseRentList?.rentElementRequestInProgress,
    rentedItems: state.warehouseRentList?.rentedItems || {},
    errors: state.warehouseRentList?.errors || [],
  }
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return {
    loadData: (data) => dispatch(loadData(data)),
  }
}

export default connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, mapDispatchToProps)
